// extracted by mini-css-extract-plugin
export default {"clearSlotButton":"styles_clearSlotButton__N8Eec","clearState":"styles_clearState__vRdzs"};